<button 
    size="small" 
    p-button  
    [pTooltip]="selected ? tooltipContent : ''"  
    tooltipPosition="bottom" 
    class="ml-3 split-button-orange-1"
    type="button" 
    [class.active]="data.length > 0" 
    (click)="showOverlayPanel($event)">
    {{label}}
</button>

<p-overlayPanel #op (onHide)="hideOverlayPanel()" appendTo="body">
    <div class="split-dropdown-panel">
        <div class="split-dropdown-header">
            <split-search  class="w-full" (valueChange)="onSearch($event)"></split-search>
        </div>
        <div class="split-dropdown-list">
            <div class="split-dropdown-item" *ngFor="let dataFilter of data; let i = index">
                <!--<p-radioButton 
                name="pizza" 
                value="Cheese" 
                [(ngModel)]="ingredient" 
                inputId="ingredient1" />-->
                <p-radioButton (click)="$event.stopPropagation()" name="pizza" [value]="dataFilter"  [(ngModel)]="_selected" (onClick)="onChange($event, i)"  [inputId]="dataFilter.name"></p-radioButton>
                <label class="ml-1" [for]="dataFilter.id">{{dataFilter.name}}</label>
            </div>
        </div>
        <div class="split-dropdown-footer">
            <p-button (click)="onEmit()" label="aplicar"></p-button>
        </div>
      </div>
</p-overlayPanel>

<ng-template #tooltipContent>
    <p class="my-1">Filtros selecionados: </p>
    <ul class="pl-4">
        <li>{{ selected?.name }}</li>
    </ul>
</ng-template>
